/* Puts the letter's pull-quote on each frame card, just above the title.

   Why JavaScript rather than Liquid: the collection grid renders through the
   theme's own snippets/card-product.liquid, a ~900 line file shared by every
   product card in the shop. Rewriting the whole file through the Admin API to
   add four lines risks corrupting it. This does the same job from the outside
   and touches nothing the theme owns.

   The quotes themselves come from the page, not from here — a
   frame-quote-data snippet writes window.IraFrameQuotes as a handle -> quote
   map.

   It used to inject the quote INTO .card__media as an overlay. The catalogue
   artwork now has an illustrated face in that band, so the quote moved below
   the picture. See frame-quote.css. */

(function () {
  'use strict';

  var CLASS = 'frame-quote';

  function quoteFor(card) {
    var quotes = window.IraFrameQuotes;
    if (!quotes) return null;

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    // /products/aaji-to-nat-%E0%A4%86%E0%A4%9C... -> the handle
    var handle = link.getAttribute('href').split('/products/')[1];
    if (!handle) return null;
    handle = handle.split('?')[0].split('#')[0].replace(/\/$/, '');

    // Handles here contain Devanagari, so the href arrives percent-encoded
    // while the map is keyed on the raw handle. Without this the lookup
    // silently misses on every single product.
    try {
      handle = decodeURIComponent(handle);
    } catch (e) {}

    return quotes[handle] || null;
  }

  /* Where the text block of a card lives, in the theme's order of preference.
     Falling back rather than assuming one class keeps this working across the
     theme's two card styles, and if none of them match we append to the card
     itself — below the price is worse than nowhere, but not by much, and it
     is never silently invisible. */
  function textBlock(card) {
    return card.querySelector('.card__information')
      || card.querySelector('.card-information')
      || card.querySelector('.card__content')
      || card;
  }

  function decorate(card) {
    if (card.querySelector('.' + CLASS)) return;

    // Only frames that reserve a blank band get a quote; the older square
    // artwork fills the whole sheet. The map only contains generated frames,
    // so a miss here is the filter.
    var quote = quoteFor(card);
    if (!quote) return;

    var wrap = document.createElement('div');
    wrap.className = CLASS;
    wrap.setAttribute('aria-hidden', 'true');

    var text = document.createElement('span');
    text.className = CLASS + '__text';
    text.textContent = quote;

    wrap.appendChild(text);

    var host = textBlock(card);
    host.insertBefore(wrap, host.firstChild);
  }

  function run(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(decorate);
  }

  run();

  // Filtering and pagination replace the grid without a page load, so watch
  // for new cards rather than assuming the first pass caught everything.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var node = records[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList.contains('card-wrapper')) decorate(node);
          else run(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
